<template>
    <div>
        <a-row>
            <a-col :span="2">
                医疗机构：
            </a-col>
            <a-col :span="4">
                <a-input v-model.trim="compId"/>
            </a-col>
            <a-col :span="1">
                状态
            </a-col>
            <a-col :span="4">
              <a-select v-model="state" style="width: 220px" >
                <a-select-option value="">
                  全部
                </a-select-option>
                <a-select-option value="0">
                  接收
                </a-select-option>
                <a-select-option value="1">
                  存储
                </a-select-option>
                <a-select-option value="2">
                  处置
                </a-select-option>
              </a-select>
            </a-col>
            <a-col :span="2">
                接收开始时间:
            </a-col>
            <a-col :span="4">
                <my-date :date-value.sync="AcceptDate_Begin" :placeholder="'接收开始时间'"/>
            </a-col>
            <a-col :span="2">
                接收结束时间
            </a-col>
            <a-col :span="4">
                <my-date :date-value.sync="AcceptDate_End" :placeholder="'接收结束时间'"/>
            </a-col>
        </a-row>
        <a-row>
          <a-col :span="2">
            处置开始时间:
          </a-col>
          <a-col :span="4">
              <my-date :date-value.sync="DisposeTime_Begin" :placeholder="'处置开始时间'"/>
          </a-col>
          <a-col :span="2">
            处置结束时间:
          </a-col>
          <a-col :span="4">
              <my-date :date-value.sync="DisposeTime_End" :placeholder="'处置结束时间'"/>
          </a-col>
          <a-col :span="2 ">
              <a-button type="primary" @click="look">
                  查询
              </a-button>
          </a-col>
        </a-row>
        <a-table :columns="columns" :data-source="data.data" bordered :scroll="{y:'65vh'}" :pagination="false" rowKey="id">
          <template slot="operation" slot-scope="text, record">
                <a @click="dispose(text, record)"  v-if="record.state=='1'">处置</a>
                <!-- <a-divider type="vertical"  v-if="record.state=='1'"/> -->
                <!-- <a @click="lookDetails(text, record)">详情</a> -->
          </template>
        </a-table>
        <my-page :data="data" @change="onChange"/>
    </div>
</template>

<script>
    import {queryList,dispose} from './js/ApiQuery'

    const columns = [
        // {
        //     title: '序号',
        //     dataIndex: 'orderNo',
        //     key: 'orderNo',
        //     ellipsis: true,
        // },
        {
            title: '医疗机构',
            dataIndex: 'compId',
            key: 'compId',
            ellipsis: true,
        },
        {
            title: '医废类别',
            dataIndex: 'type',
            key: 'type',
            ellipsis: true,
        },
        {
            title: '重量',
            dataIndex: 'weight',
            key: 'weight',
            ellipsis: true,
        },
        {
            title: '交货人',
            dataIndex: 'putUserName',
            key: 'putUserName',
            ellipsis: true,
        },
        {
            title: '接收人',
            dataIndex: 'saveUserName',
            key: 'saveUserName',
            ellipsis: true,
        },
        {
            title: '接收时间',
            dataIndex: 'acceptDate',
            key: 'acceptDate',
            ellipsis: true,
        },
        {
            title: '存储时间',
            dataIndex: 'saveTime',
            key: 'saveTime',
            ellipsis: true,
        },
        {
            title: '处置时间',
            dataIndex: 'disposeTime',
            key: 'disposeTime',
            ellipsis: true,
        },
        {
          title: '操作',
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
        },

    ];
    export default {
        data() {
            return {
                columns,
                data: {},
                compId: '',
                state:'',
                AcceptDate_Begin:'',
                AcceptDate_End:'',
                DisposeTime_Begin:'',
                DisposeTime_End:''
            }
        },
        methods: {
          // 处置
          dispose(text, record){
            var obj = {
              id:record.id,
              disposeUser:record.disposeUser,
              desc:record.desc
            }
            dispose(obj).then(res =>{
              if (res.status==0) {
                this.look()
              }
            })

          },
          // 查看详情
          lookDetails(text, record){
            console.log(record);
          },
            getData(parameter) {
                queryList(parameter).then(res => {
                    this.data = res.data
                })
            },
            // 查询
            look() {
                let baseDto = {
                    pageIndex:1,
                    pageSize:10,
                    compId:this.compId,
                    state:this.state,
                    AcceptDate_Begin:this.AcceptDate_Begin,
                    AcceptDate_End:this.AcceptDate_End,
                    DisposeTime_Begin:this.DisposeTime_Begin,
                    DisposeTime_End:this.DisposeTime_End
                };
                this.getData({baseDto:baseDto});
            },
            // 分页
            onChange(page) {
                let baseDto = {
                    pageIndex: page,
                    pageSize:10,
                    compId:this.compId,
                    state:this.state,
                    AcceptDate_Begin:this.AcceptDate_Begin,
                    AcceptDate_End:this.AcceptDate_End,
                    DisposeTime_Begin:this.DisposeTime_Begin,
                    DisposeTime_End:this.DisposeTime_End
                };
                this.getData({baseDto: baseDto});
            },
        },
        created() {
            let baseDto = {
                pageIndex:1,
                pageSize:10,
                compId:this.compId,
                state:this.state,
                AcceptDate_Begin:this.AcceptDate_Begin,
                AcceptDate_End:this.AcceptDate_End,
                DisposeTime_Begin:this.DisposeTime_Begin,
                DisposeTime_End:this.DisposeTime_End
            };
            this.getData({baseDto:baseDto});
        }
    }
</script>

<style scoped>

</style>
